var map = {
	"./nav-color-gold.svg": 177,
	"./nav-color-multicolor.svg": 178,
	"./nav-color-palladium.svg": 239,
	"./nav-color-platinum.svg": 179,
	"./nav-color-redgold.svg": 116,
	"./nav-color-rosegold.svg": 180,
	"./nav-color-signature.svg": 181,
	"./nav-color-silver.svg": 261,
	"./nav-color-whitegold.svg": 182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 904;